export default __webpack_public_path__ + "static/media/calendar.55688ab6.svg";